<template>
  <div>
    <!-- SerialNumberNew component content -->
    <section>
     <div class="row pb-3">
        <div class="col-md-12">
          <div class="form-group" :class="{ 'has-error': packageCodeError }">
                <label for="package_code">Package Code</label>
                <input type="text" class="form-control" id="package_code" name="package_code" aria-describedby="tppackage_code"
                    placeholder="Package Code" autocomplete="on" v-model="package_code" readonly>
                <label v-if="packageCodeError" for="package_code" class="error">{{ packageCodeError }}</label>
            </div>
        </div>
      </div>
      <div class="row pb-3">
        <div class="col-md-7">
          <div class="form-group" :class="{ 'has-error': packageBarcodeError }">
                <label for="package_barcode">Package Barcode</label>
                <input type="text" class="form-control" id="package_barcode" name="package_barcode" aria-describedby="tppackage_barcode"
                    placeholder="Package Barcode" autocomplete="on" v-model="package_barcode">
                <label v-if="packageBarcodeError" for="package_barcode" class="error">{{ packageBarcodeError }}</label>
            </div>
        </div>
        <div class="col-md-3 col-sm-12" v-if="isMobile()">
          <div class="mb-3">
            <button 
              @click="toggleBarcodeCamera" 
              class="btn btn-success btn-block"
              type="button"
            >
              <i class="fas fa-camera"></i> 
              {{ barcodeCameraActive ? 'Stop Camera' : 'Start Camera' }}
            </button>
          </div>
          <div id="qr-code-full-region-package-barcode" v-show="barcodeCameraActive"></div>
        </div>
        <div class="col-md-3 col-sm-12" v-else>
          <div class="mb-3">
            <button 
              @click="startBarcodeScanning" 
              class="btn btn-block mb-2"
              :class="barcodeCameraActive ? 'btn-success' : 'btn-primary'"
              type="button"
            >
              <i class="fas fa-qrcode"></i> 
              {{ barcodeCameraActive ? 'Scanner Active' : 'Scan Barcode/QR Code' }}
            </button>
            <button 
              @click="stopBarcodeCamera" 
              class="btn btn-danger btn-block"
              type="button"
              v-if="barcodeCameraActive"
            >
              <i class="fas fa-stop"></i> 
              Stop Camera
            </button>
          </div>
          <div id="qr-code-full-region-package-barcode" v-show="barcodeCameraActive"></div>
        </div>
      </div>
      <div
        v-for="(msg, index) in message"
        :key="index"
        style="white-space: pre-line"
      >
        <pre>decodedResult => {{ msg.decodedResult }}</pre>
      </div>
    </section>
  </div>
</template>

<script>
import { Html5QrcodeScanner } from "html5-qrcode";
// To use Html5Qrcode (more info below)
import {Html5Qrcode, Html5QrcodeSupportedFormats} from "html5-qrcode"
import cameraManager from '../services/CameraManager.js'
export default {
  name: 'PackageCode',
  props: {
    initialPackageCode: {
      type: String,
      default: ''
    },
    itemcode: {
      type: Array,
      default: () => []
    },
    orderitems: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    serialnumbers: {
      type: Array,
      default: () => []
    },
    package: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
        package_code: "",
      packageCodeError: "",
      package_barcode: "",
      packageBarcodeError: "",
      incremental: false,
      value: "",
      countries: [],
      packages: [],
      options: [],
      item_serial_numbers: [],
      item_serial_numbers_select: [],
      isLoading: false,
      item_type: 'type',
      search_term: "",
      scanned: false,
      message: [],
      incrementals: [],
      barcodeCameraActive: false,
      barcodeHtml5QrCode: null,
      localItems: [],
      activeBarcodeCamera: null
    };
  },
  mounted() {

    console.log(this.package)
    console.log("Component mounted.");
    console.log(this.items);
    
    // Initialize package_code from props if provided
    if (this.initialPackageCode) {
      this.package_code = this.initialPackageCode;
    }
    
    // Initialize package_barcode from package prop if provided
    if (this.package) {
      this.package_code = this.package.package_code;
    }
    
    this.countries = [...this.itemcode];
    this.localItems = [...(this.orderitems.length ? this.orderitems : this.items)];
    // Register with camera manager
    cameraManager.register(this);
    this.addItem();
  },
  beforeDestroy() {
    // Clean up cameras and unregister from manager
    this.stopBarcodeCamera();
    cameraManager.unregister(this);
  },
  methods: {
    validateForm(index){
      if(this.incrementals[index].starting > this.incrementals[index].ending || (incremental.starting != '' && incremental.ending == '')){
        $('#submit').prop("disabled",true);
      }else{
        $('#submit').prop("disabled",false);
      }
    },
    addItem() {
      this.incrementals.push({
        prefix: "",
        suffix: "",
        starting: "",
        ending: "",
      });
    },
    removeItem(index) {
      this.incrementals.splice(index, 1);
    },
    toggleBarcodeCamera() {
      if (this.barcodeCameraActive) {
        this.stopBarcodeCamera();
      } else {
        this.startBarcodeScanning();
      }
    },
    // Handle camera state changes from other components
    onCameraStateChanged(activeComponent, componentName) {
      if (activeComponent !== this && this.barcodeCameraActive) {
        console.log(`Camera taken by ${componentName}, stopping PackageCode cameras`);
        this.stopBarcodeCamera();
      }
    },
    startBarcodeScanning() {
      // Request camera access through camera manager
      cameraManager.requestCamera(this, 'PackageCode-Barcode');
      
      this.barcodeCameraActive = true;
      this.$nextTick(() => {
        this.createBarcodeScan();
      });
    },
    
    stopBarcodeCamera() {
      if (this.barcodeHtml5QrCode) {
        this.barcodeHtml5QrCode.stop().then(() => {
          this.barcodeCameraActive = false;
          this.barcodeHtml5QrCode = null;
          cameraManager.releaseCamera(this);
        }).catch((err) => {
          console.log(err);
          this.barcodeCameraActive = false;
          this.barcodeHtml5QrCode = null;
          cameraManager.releaseCamera(this);
        });
      } else {
        this.barcodeCameraActive = false;
        cameraManager.releaseCamera(this);
      }
    },
    
    createBarcodeScan() {
      Html5Qrcode.getCameras().then(devices => {
        if (devices && devices.length) {
          var cameraId = devices[0].id;
          this.barcodeHtml5QrCode = new Html5Qrcode('qr-code-full-region-package-barcode', true);
          
          const config = {
            fps: 10,
            qrbox: 250,
            aspectRatio: 2,
            supportedScanTypes: ['SCAN_TYPE_CAMERA'],
            formatsToSupport: [
              Html5QrcodeSupportedFormats.CODE_128,
              Html5QrcodeSupportedFormats.CODE_39,
              Html5QrcodeSupportedFormats.EAN_13,
              Html5QrcodeSupportedFormats.EAN_8,
              Html5QrcodeSupportedFormats.UPC_A,
              Html5QrcodeSupportedFormats.UPC_E
            ]
          };
          
          this.barcodeHtml5QrCode.start(
            { facingMode: { exact: "environment"} },
            config,
            (decodedText, decodedResult) => {
              // Set the barcode value to the package barcode field
              this.setPackageBarcode(decodedText);
            },
            (errorMessage) => {
              // Ignore scan errors
            }
          ).catch((err) => {
            console.log(err);
          });
        }
      }).catch(err => {
        console.log(err);
      });
    },
    setPackageBarcode(decodedText) {
      // Set the package barcode from scan
      this.package_barcode = decodedText;
      
      // Play beep sound
      var audio = new Audio('/audio/Barcode-scanner-beep-sound.mp3');
      audio.play();
      
      // Stop the camera after successful scan
      this.stopBarcodeCamera();
    },


    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },


    removeVal(tag){
      console.log(tag)
      const index = this.item_serial_numbers.indexOf(tag.serial_number);
      if (index > -1) {
        this.item_serial_numbers.splice(index, 1); // 2nd parameter means remove one item only
      }
    },
    updateModel(newTag){
      this.item_serial_numbers.push(newTag.serial_number)
      this.serialnumbers.push(newTag)
    },
    addTag (newTag) {
      const tag = {
        serial_number: newTag,
        item_code: '',
      }
      var exist = false;
      for (let index = 0; index < this.item_serial_numbers_select.length; index++) {
        if(this.item_serial_numbers_select[index].serial_number == newTag){
          exist = true
        }
      }
      if(!exist){
        if(this.scanned){
          var audio = new Audio('/audio/Barcode-scanner-beep-sound.mp3'); // path to file
          audio.play();
          this.scanned = false
        }
        this.serialnumbers.push(tag)
        this.item_serial_numbers_select.push(tag)
        this.item_serial_numbers.push(newTag)
      }else{
        // alert('Serial Number already chosen')
      }
    },
    setSerialNoVal(){
      this.item_serial_numbers = ''
      for (let index = 0; index < this.item_serial_numbers_select.length; index++) {
        this.item_serial_numbers += this.item_serial_numbers_select[index].serial_number+', '
      }
    },
    limitText(count) {
      return `and ${count} other countries`;
    },
    asyncFind(query) {
      this.search_term = query;
      if (query && query != "") {
        this.isLoading = true;
        axios
          .get("/ajax/search-ac?parameter=" + query)
          .then((response) => {
            if (this.search_term == response.data.search_term) {
              this.countries = response.data.data;
              this.isLoading = false;
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    asyncPackageFind(query) {
      this.search_term = query;
      if (query && query != "") {
        this.isLoading = true;
        axios
          .get("/ajax/search-ac-package?parameter=" + query)
          .then((response) => {
            if (this.search_term == response.data.search_term) {
              this.packages = response.data.data;
              this.isLoading = false;
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    clearAll() {
      this.selectedCountries = [];
    },
    packageQtyChange(index1) {
      if (this.localItems[index1].package_items) {
        for (
          let index = 0;
          index < this.localItems[index1].package_items.length;
          index++
        ) {
          this.localItems[index1].package_items[index].item_quantity = this.localItems[
            index1
          ].package_items[index].item_quantity
            ? this.localItems[index1].package_items[index].item_quantity *
              this.localItems[index1].quantity
            : "";
        }
      }
    },
    setItemVal() {
      this.countries = [];
    },
    setPackageVal(item) {
      this.packages = [];
      if (item && item.package_code && item.package_code.package_dockey != "") {
        this.isLoading = true;
        var search = item.package_code.package_dockey;
        axios
          .get("/ajax/search-ac-package-item?parameter=" + search)
          .then((response) => {
            for (let index = 0; index < item.package_items.length; index++) {
              item[index1].package_items[index].item_quantity = item
                .package_items[index].item_quantity
                ? item.package_items[index].item_quantity * item.quantity
                : "";
            }
            item.package_items = response.data.data;
            this.isLoading = false;
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    retrieveItemCode() {
      axios
        .get("/ajax/search-ac?parameter=" + this.localItems[index].item_code)
        .then(({ data }) => {
          var a = [];
          for (var i = 0; i < data.length; i++) {
            var temp = { value: data[i]["id"], name: data[i]["name"] };
            a.push(temp);
          }
          this.customers = a;
        });
    },
  }
}
</script>

<style scoped>
.has-error .form-control {
  border-color: #e74c3c;
}

.error {
  color: #e74c3c;
  font-size: 0.875em;
  margin-top: 0.25rem;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>